@use "styles" as *;

.me-backdrop {
  display: block;
  position: fixed;
  z-index: 10200;
  inset: 0;
  background: $color-background-backdrop;
  backdrop-filter: blur($me-backdrop-blur);
  background-blend-mode: overlay;
  cursor: pointer;

  &:not(&--active) {
    opacity: 0;
    visibility: hidden;
  }

  &--animated {
    transition:
      opacity $transition-timing,
      visibility $transition-timing;
  }
}
